import React from "react";
import styled from "styled-components";

import { colorFromTheme } from "../../utils/color";

const Styled = styled.div`
  display: flex;
`;

interface SharedProps {
  value?: string;
  size?: "small" | "normal" | "large";
  color?: "light-gray" | "gray";
}
interface ButtonProps extends SharedProps {
  selected?: boolean;
  radius?: string;
}

const Button = styled.button<ButtonProps>`
  --radius: ${(props) => props.radius ?? "0.5rem"};

  font-family: inherit;
  align-items: center;
  /* background-color: transparent; */
  border: none;
  padding: 0 1.1rem;
  border-radius: 0rem;
  line-height: 1.6rem;
  box-sizing: border-box;
  transition:
    border-color 0.2s,
    background-color 0.2s,
    color 0.2s;
  display: flex;
  align-items: center;
  cursor: pointer;

  color: ${colorFromTheme("primary")};
  /* background-color: #d7d7d7; */
  svg {
    fill: #555;
  }

  ${(props) => {
    switch (props.color) {
      case "light-gray":
        if (props.selected) {
          return `
          color: #222;
          background-color: #ddd;

          svg {
            fill: ##222;
          }

          &:hover {
            background-color: #ddd;
          }
          `;
        } else {
          return `
          background-color: #fff;

          &:hover {
            background-color: #f2f2f2;
          }
          `;
        }
      case "gray":
      default:
        if (props.selected) {
          return `
          color: white;
          background-color: #777;

          svg {
            fill: #fff;
          }

          &:hover {
            background-color: #777;
          }
          `;
        } else {
          return `
          background-color: #d7d7d7;

          &:hover {
            background-color: #ccc;
          }
          `;
        }
    }
  }}

  ${(props) => {
    switch (props.size) {
      case "small":
        return `
          height: 2.4rem;
          font-size: 0.9em;
        `;
      case "large":
        return `
          height: 3.4rem;
          font-size: 1.1em;
        `;
      case "normal":
      default:
        return `
          height: 3rem;
          font-size: 1em;
        `;
    }
  }}

  svg {
    display: block;
    margin-right: 0.5rem;
  }

  margin-left: -1px;

  &:first-child {
    border-radius: var(--radius) 0 0 var(--radius);
    margin-left: 0;
  }
  &:last-child {
    border-radius: 0 var(--radius) var(--radius) 0;
  }
  /* &:hover {
    background-color: #d0d0d0;
  } */

  border: solid 1px #d0d0d0;

  ${(props) => {
    if (!props.selected) {
      return `
      &:hover {
        text-decoration: underline;
      }  
      `;
    }
  }}

  ${(props) => {
    if (props.selected) {
      return `
      // box-shadow: inset 0 0 0.4rem rgba(0,0,0,0.3);
      color: #333;
      // background-color: #999;

      // &:hover {
      //   background-color: #aaa;
      // }

      // svg {
      //   display: block;
      //   fill: #fff;
      // }
      `;
    }
  }}

  &:disabled {
    color: #aaa;
    cursor: not-allowed;
  }
`;

export interface ToggleButtonProps extends SharedProps {
  value?: string;
  onClick?: (value: string) => void;
  radius?: string;
}

const ToggleButtonGroup: React.FC<
  React.PropsWithChildren<ToggleButtonProps>
> & {
  Button: typeof Button;
} = (props) => {
  return (
    <Styled>
      {React.Children.toArray(props.children).map((btn: any) => {
        return React.cloneElement(btn, {
          size: props.size,
          color: props.color,
          selected: props.value === btn.props.value,
          radius: props.radius,
          onClick: () => {
            props.onClick?.(btn.props.value);
          },
        });
      })}
    </Styled>
  );
};

ToggleButtonGroup.Button = Button;

export default ToggleButtonGroup;
